/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ succeeded: NonNullable<unknown>, failed: NonNullable<unknown> }} Chat_Invoke_Api_Batch_ResultInputs */



/**
* | output |
* | --- |
* | "{succeeded} succeeded · {failed} failed" |
*
* @param {Chat_Invoke_Api_Batch_ResultInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_invoke_api_batch_result = /** @type {((inputs: Chat_Invoke_Api_Batch_ResultInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Invoke_Api_Batch_ResultInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.succeeded} erfolgreich · ${i?.failed} fehlgeschlagen`)
	return /** @type {LocalizedString} */ (`${i?.succeeded} succeeded · ${i?.failed} failed`)
});